import {useMutation, useQueryClient} from "@tanstack/react-query";
import {FEEDBACK_ENDPOINTS} from "../../services/network/endpoints";
import {toast} from "react-toastify";
import {CreateFeedBackRequest} from "../../services/models/feedback";
import {FeedbackApi} from "../../services/network/feedback-api";

interface CreateFeedBackParams {
    data: CreateFeedBackRequest;
}

export function useCreateFeedBack() {

    return useMutation({
        mutationKey: [FEEDBACK_ENDPOINTS.CREATE],
        mutationFn: async ({data}: CreateFeedBackParams) => {
            return FeedbackApi.createFeedBack(data);
        },
        onError() {
            toast.error("Ошибка при отправке формы");
        },
        onSuccess: () => {
            toast.success("Форма обратной связи успешно отправлена");
        }
    });
}